import React from "react";

export const ImageIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6364 9.25C12.6364 11.3211 11.0083 13 9 13C6.99169 13 5.36364 11.3211 5.36364 9.25C5.36364 7.17893 6.99169 5.5 9 5.5C11.0083 5.5 12.6364 7.17893 12.6364 9.25ZM11.1818 9.25C11.1818 10.4926 10.205 11.5 9 11.5C7.79501 11.5 6.81818 10.4926 6.81818 9.25C6.81818 8.00736 7.79501 7 9 7C10.205 7 11.1818 8.00736 11.1818 9.25Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.09091 1C5.77787 1 5.49995 1.20657 5.40096 1.51283L4.83945 3.25H3.18182C1.97683 3.25 1 4.25736 1 5.5V13.75C1 14.9926 1.97683 16 3.18182 16H14.8182C16.0232 16 17 14.9926 17 13.75V5.5C17 4.25736 16.0232 3.25 14.8182 3.25H13.1606L12.599 1.51283C12.5001 1.20657 12.2221 1 11.9091 1H6.09091ZM6.05359 4.23717L6.6151 2.5H11.3849L11.9464 4.23717C12.0454 4.54343 12.3233 4.75 12.6364 4.75H14.8182C15.2198 4.75 15.5455 5.08579 15.5455 5.5V13.75C15.5455 14.1642 15.2198 14.5 14.8182 14.5H3.18182C2.78016 14.5 2.45455 14.1642 2.45455 13.75V5.5C2.45455 5.08579 2.78016 4.75 3.18182 4.75H5.36364C5.67668 4.75 5.9546 4.54343 6.05359 4.23717Z"
    />
  </svg>
);
